module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/signs-of-spring/"},"excerpt":"Everyone knows spring has arrived when the trees are in bloom and they hear the chirping of birds that have been absent all winter…","timeToRead":1,"frontmatter":{"title":"Signs of Spring","tags":["birds","blossoms","spring"]}}}]}},"pathContext":{"tag":"spring"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tags-spring.json
// module id = 774
// module chunks = 73951219910528